import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import { formatClassNames } from '../../utilities'

class LabeledButton extends Component {

  render() {
    const {
      label,
      toggleValues,
      value,
      onClick,
      disabled,
      showTooltips
    } = this.props

    const formattedLabel = label.replace(/[()]/g, '')
    const buttonLabel = toggleValues.find(v => v.value === value)?.label
    const valueIndex = toggleValues.findIndex(v => v.value === value)

    return (
      <div
        className={classnames('labeled-item', 'label-button', formatClassNames(formattedLabel), {'disabled': disabled}, valueIndex === 0 ? 'off' : 'on')}
        data-tip={this.props['tip']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
      >
        <label className='number-input-label'>{label}</label>
        <button
          onClick={() => {
            const toggleIndex = Number(!Boolean(valueIndex))
            const value = toggleValues[toggleIndex]?.value
            onClick(value)
          }}
        >{buttonLabel}</button>
      </div>
    )
  }
}



const mapStateToProps = (state) => {
  return {
    showTooltips: state.editorPreferences.showTooltips
  }
}

export default connect(mapStateToProps, null)(LabeledButton)